import { useRef } from "react";
import s from "./Accordion.module.scss";

type AccordionProps = {
  index?: number;
  title: string;
  description: string;
  isOpen: boolean;
  toggle: (index: number) => void;
  size: "small" | "large";
};

const Accordion = ({
  index,
  title,
  description,
  isOpen,
  toggle,
  size,
}: AccordionProps) => {
  const descriptionRef = useRef<HTMLDivElement | null>(null);

  const getHeight = () =>
    isOpen && descriptionRef.current
      ? `${descriptionRef.current.scrollHeight + 16}px`
      : "0";

  const getPadding = () => (isOpen ? `16px` : "0");

  return (
    <div
      className={`${s.accordion} ${
        size === "small" ? s["accordion--small"] : s["accordion--large"]
      }`}
      onClick={() => toggle(index || 0)}
    >
      <div className={s.accordion__titleBox}>
        <div className={s.accordion__border}>
          <h3
            className={`${s.accordion__title} ${
              size === "small"
                ? s["accordion__title--small"]
                : s["accordion__title--large"]
            }`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div className={s.accordion__cross}>
            <div
              className={`${s.accordion__crossSymbolOne} ${
                isOpen ? `${s["accordion__crossSymbolOne--active"]}` : ""
              }`}
            ></div>
            <div
              className={`${s.accordion__crossSymbolTwo} ${
                isOpen ? `${s["accordion__crossSymbolTwo--active"]}` : ""
              }`}
            ></div>
          </div>
        </div>
        <p
          className={s.accordion__descriptionWrapper}
          style={{ paddingTop: getPadding(), maxHeight: getHeight() }}
          ref={descriptionRef}
        >
          <span
            className={`${s.accordion__description} ${
              size === "small"
                ? s["accordion__description--small"]
                : s["accordion__description--large"]
            }`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </p>
      </div>
    </div>
  );
};

export default Accordion;
